import {
  ACT_DYNASTIES_FETCH_INIT,
  ACT_DYNASTIES_FETCH_200,
} from '../constants/actions';

const defaultState = {
  isLoadingDynasties: false,
  didLoadDynasties: false,
  dynastiesList: [],
};

const dynastiesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case ACT_DYNASTIES_FETCH_INIT:
      return {
        ...state,
        isLoadingDynasties: true,
        didLoadDynasties: false,
        dynastiesList: [],
      };
    case ACT_DYNASTIES_FETCH_200:
      return {
        ...state,
        isLoadingDynasties: false,
        didLoadDynasties: true,
        dynastiesList: action.payload,
      };
    default:
      return state;
  }
};

export default dynastiesReducer;
